export const userRole = [

  {
    name: "Bidding",
    roles: [
      {
        id: 23,
        name: "bids_view",
      },
      {
        id: 24,
        name: "bids_create",
      },
      {
        id: 25,
        name: "bids_edit",
      },
      {
        id: 26,
        name: "bids_delete",
      },
      {
        id: 27,
        name: "estimation_view",
      },
      {
        id: 28,
        name: "estimation_create",
      },
      {
        id: 29,
        name: "estimation_edit",
      },
      {
        id: 30,
        name: "estimation_delete",
      },
        {
        id: 15,
        name: "activity_item_view",
      },
      {
        id: 16,
        name: "activity_item_create",
      },
      {
        id: 17,
        name: "activity_item_edit",
      },
      {
        id: 18,
        name: "activity_item_delete",
      },
      {
        id: 19,
        name: "terms_and_condition_view",
      },
      {
        id: 20,
        name: "terms_and_condition_create",
      },
      {
        id: 21,
        name: "terms_and_condition_edit",
      },
      {
        id: 22,
        name: "terms_and_condition_delete",
      }
    ],
  },
  {
    name: "Project",
    roles: [
      {
        id: 31,
        name: "project_view",
      },
      {
        id: 32,
        name: "project_create",
      },
      {
        id: 33,
        name: "project_edit",
      },
      {
        id: 34,
        name: "project_delete",
      },
      {
        id: 35,
        name: "manpower_view",
      },
      {
        id: 36,
        name: "manpower_create",
      },
      {
        id: 37,
        name: "manpower_edit",
      },
      {
        id: 38,
        name: "manpower_delete",
      },
      {
        id: 39,
        name: "material_view",
      },
      {
        id: 40,
        name: "material_create",
      },
      {
        id: 41,
        name: "material_edit",
      },
      {
        id: 42,
        name: "material_delete",
      },
      {
        id: 43,
        name: "others_view",
      },
      {
        id: 44,
        name: "others_create",
      },
      {
        id: 45,
        name: "others_edit",
      },
      {
        id: 46,
        name: "others_delete",
      },
      {
        id: 47,
        name: "activities_view",
      },
      {
        id: 48,
        name: "activities_create",
      },
      {
        id: 49,
        name: "activities_edit",
      },
      {
        id: 50,
        name: "activities_delete",
      },
      {
        id: 51,
        name: "timeline_view",
      },
      {
        id: 52,
        name: "timeline_edit",
      }
    ],
  },
  {
    name: "Task",
    roles: [
      {
        id: 53,
        name: "my_task_view",
      },
      {
        id: 54,
        name: "my_task_update",
      },
      {
        id: 55,
        name: "all_task_view",
      },
      {
        id: 56,
        name: "all_task_update",
      }
    ],
  },
  {
    name: "Progress",
    roles: [
      {
        id: 57,
        name: "man_hour_view",
      },
      {
        id: 58,
        name: "man_hour_create",
      },
      {
        id: 59,
        name: "man_hour_edit",
      },
      {
        id: 60,
        name: "man_hour_delete",
      },
      {
        id: 61,
        name: "installation_view",
      },
      {
        id: 62,
        name: "installation_create",
      },
      {
        id: 63,
        name: "installation_edit",
      },
      {
        id: 64,
        name: "installation_delete",
      }
    ],
  },
  {
    name: "Finance",
    roles: [
      {
        id: 65,
        name: "incoming_view",
      },
      {
        id: 66,
        name: "incoming_create",
      },
      {
        id: 67,
        name: "incoming_edit",
      },
      {
        id: 68,
        name: "incoming_delete",
      },
      {
        id: 69,
        name: "outgoing_view",
      },
      {
        id: 70,
        name: "outgoing_create",
      },
      {
        id: 71,
        name: "outgoing_edit",
      },
      {
        id: 72,
        name: "outgoing_delete",
      },
      {
        id: 73,
        name: "other_expenses_view",
      },
      {
        id: 74,
        name: "other_expenses_create",
      },
      {
        id: 75,
        name: "other_expenses_edit",
      },
      {
        id: 76,
        name: "other_expenses_delete",
      },
      {
        id: 77,
        name: "received_view",
      },
      {
        id: 78,
        name: "received_create",
      },
      {
        id: 79,
        name: "received_edit",
      },
      {
        id: 80,
        name: "received_delete",
      },
      {
        id: 81,
        name: "issued_view",
      },
      {
        id: 82,
        name: "issued_create",
      },
      {
        id: 83,
        name: "issued_edit",
      },
      {
        id: 84,
        name: "issued_delete",
      },
      {
        id: 153,
        name: "payables_view",
      },
      {
        id: 154,
        name: "payables_create",
      },
      {
        id: 155,
        name: "payables_edit",
      },
      {
        id: 156,
        name: "payables_delete",
      },
      {
        id: 157,
        name: "receivables_view",
      },
      {
        id: 158,
        name: "receivables_create",
      },
      {
        id: 159,
        name: "receivables_edit",
      },
      {
        id: 160,
        name: "receivables_delete",
      }
    ],
  },
  {
    name: "My Diary",
    roles: [
      {
        id: 85,
        name: "my_diary_view",
      },
      {
        id: 86,
        name: "my_diary_create",
      },
      {
        id: 87,
        name: "my_diary_edit",
      },
      {
        id: 88,
        name: "my_diary_delete",
      }
    ],
  },
  {
    name: "Contacts",
    roles: [
      {
        id: 89,
        name: "employees_view",
      },
      {
        id: 90,
        name: "employees_create",
      },
      {
        id: 91,
        name: "employees_edit",
      },
      {
        id: 92,
        name: "employees_delete",
      },
      {
        id: 93,
        name: "suppliers_view",
      },
      {
        id: 94,
        name: "suppliers_create",
      },
      {
        id: 95,
        name: "suppliers_edit",
      },
      {
        id: 96,
        name: "suppliers_delete",
      },
      {
        id: 97,
        name: "sub_contractor_view",
      },
      {
        id: 98,
        name: "sub_contractor_create",
      },
      {
        id: 99,
        name: "sub_contractor_edit",
      },
      {
        id: 100,
        name: "sub_contractor_delete",
      },
      {
        id: 101,
        name: "rental_manpower_view",
      },
      {
        id: 102,
        name: "rental_manpower_create",
      },
      {
        id: 103,
        name: "rental_manpower_edit",
      },
      {
        id: 104,
        name: "rental_manpower_delete",
      },
     
      {
        id: 109,
        name: "customers_view",
      },
      {
        id: 110,
        name: "customers_create",
      },
      {
        id: 111,
        name: "customers_edit",
      },
      {
        id: 112,
        name: "customers_delete",
      },
      {
        id: 190,
        name: "shipping_view",
      },
      {
        id: 191,
        name: "agents_view",
      },
      {
        id: 192,
        name: "agents_create",
      },
      {
        id: 193,
        name: "agents_edit",
      },
      {
        id: 194,
        name: "agents_delete",
      },
    ],
  },
  {
    name: "Timesheet",
    roles: [
      {
        id: 113,
        name: "attendance_view",
      },
      {
        id: 114,
        name: "attendance_create",
      },
      {
        id: 115,
        name: "attendance_edit",
      },
      {
        id: 116,
        name: "attendance_delete",
      },
      {
        id: 117,
        name: "timesheets_view",
      }
    ],
  },
  {
    name: "Teams",
    roles: [
      {
        id: 118,
        name: "team_view",
      },
      {
        id: 119,
        name: "team_create",
      },
      {
        id: 120,
        name: "team_edit",
      },
      {
        id: 121,
        name: "team_delete",
      }
    ],
  },
  {
    name: "Procurement",
    roles: [
       {
        id: 105,
        name: "product_view",
      },
      {
        id: 106,
        name: "product_create",
      },
      {
        id: 107,
        name: "product_edit",
      },
      {
        id: 108,
        name: "product_delete",
      },
      {
        id: 122,
        name: "procurement_view",
      },
      {
        id: 123,
        name: "purchase_request_view",
      },
      {
        id: 124,
        name: "purchase_request_create",
      },
      {
        id: 125,
        name: "purchase_request_edit",
      },
      {
        id: 126,
        name: "purchase_request_delete",
      },
      {
        id: 127,
        name: "rfq_view",
      },
      {
        id: 128,
        name: "rfq_create",
      },
      {
        id: 129,
        name: "rfq_edit",
      },
      {
        id: 130,
        name: "rfq_delete",
      },
      {
        id: 131,
        name: "supplier_quote_view",
      },
      {
        id: 132,
        name: "supplier_quote_create",
      },
      {
        id: 133,
        name: "supplier_quote_edit",
      },
      {
        id: 134,
        name: "supplier_quote_delete",
      },
      {
        id: 135,
        name: "quote_compare_view",
      },
      {
        id: 136,
        name: "purchase_order_view",
      },
      {
        id: 137,
        name: "purchase_order_create",
      },
      {
        id: 138,
        name: "purchase_order_edit",
      },
      {
        id: 139,
        name: "purchase_order_delete",
      },
      {
        id: 140,
        name: "payment_request_view",
      },
      {
        id: 141,
        name: "payment_request_create",
      },
      {
        id: 142,
        name: "payment_request_edit",
      },
      {
        id: 143,
        name: "payment_request_delete",
      },
       ],
  },
  {
    name: "Invoice",
    roles: [
      {
        id: 144,
        name: "payment_view",
      },
      {
        id: 145,
        name: "invoice_in_view",
      },
      {
        id: 146,
        name: "invoice_in_create",
      },
      {
        id: 147,
        name: "invoice_in_edit",
      },
      {
        id: 148,
        name: "invoice_in_delete",
      },
      {
        id: 149,
        name: "invoice_out_view",
      },
      {
        id: 150,
        name: "invoice_out_create",
      },
      {
        id: 151,
        name: "invoice_out_edit",
      },
      {
        id: 152,
        name: "invoice_out_delete",
      }
    ],
  },
  {
    name: "Store",
    roles: [
        {
        id: 195,
        name: "shipment_tracking_view",
      },
      {
        id: 196,
        name: "shipment_tracking_create",
      },
      {
        id: 197,
        name: "shipment_tracking_edit",
      },
      {
        id: 198,
        name: "shipment_tracking_delete",
      },
      {
        id: 161,
        name: "store_view",
      },
      {
        id: 162,
        name: "assets_view",
      },
      {
        id: 163,
        name: "assets_create",
      },
      {
        id: 164,
        name: "assets_edit",
      },
      {
        id: 165,
        name: "assets_delete",
      },
      {
        id: 166,
        name: "inventory_view",
      },
      {
        id: 167,
        name: "inventory_create",
      },
      {
        id: 168,
        name: "inventory_edit",
      },
      {
        id: 169,
        name: "inventory_delete",
      },
      {
        id: 170,
        name: "grn_view",
      },
      {
        id: 171,
        name: "grn_create",
      },
      {
        id: 172,
        name: "grn_edit",
      },
      {
        id: 173,
        name: "grn_delete",
      },
      {
        id: 174,
        name: "delivery_notes_view",
      },
      {
        id: 175,
        name: "delivery_notes_create",
      },
      {
        id: 176,
        name: "delivery_notes_edit",
      },
      {
        id: 177,
        name: "delivery_notes_delete",
      },
      {
        id: 178,
        name: "returns_view",
      },
      {
        id: 179,
        name: "returns_create",
      },
      {
        id: 180,
        name: "returns_edit",
      },
      {
        id: 181,
        name: "returns_delete",
      },
      {
        id: 182,
        name: "packing_list_view",
      },
      {
        id: 183,
        name: "packing_list_create",
      },
      {
        id: 184,
        name: "packing_list_edit",
      },
      {
        id: 185,
        name: "packing_list_delete",
      },
      {
        id: 186,
        name: "requests_view",
      },
      {
        id: 187,
        name: "requests_create",
      },
      {
        id: 188,
        name: "requests_edit",
      },
      {
        id: 189,
        name: "requests_delete",
      }
    ],
  },
 
  {
    name: "Report",
    roles: [
      {
        id: 199,
        name: "report_view",
      },
      {
        id: 200,
        name: "report_generate",
      }
    ],
  },
  {
    name: "Settings",
    roles: [
      {
        id: 201,
        name: "settings_view",
      },
      {
        id: 202,
        name: "profile_settings_view",
      },
      {
        id: 203,
        name: "profile_settings_edit",
      },
      {
        id: 204,
        name: "company_info_view",
      },
      {
        id: 205,
        name: "company_info_create",
      },
      {
        id: 206,
        name: "company_info_edit",
      },
      {
        id: 207,
        name: "company_info_delete",
      },
      {
        id: 208,
        name: "user_view",
      },
      {
        id: 209,
        name: "user_create",
      },
      {
        id: 210,
        name: "user_edit",
      },
      {
        id: 211,
        name: "user_delete",
      },
      {
        id: 212,
        name: "role_view",
      },
      {
        id: 213,
        name: "role_create",
      },
      {
        id: 214,
        name: "role_edit",
      },
      {
        id: 215,
        name: "role_delete",
      },
      {
        id: 216,
        name: "user_role_view",
      },
      {
        id: 217,
        name: "user_role_create",
      },
      {
        id: 218,
        name: "user_role_edit",
      },
      {
        id: 219,
        name: "user_role_delete",
      },
      {
        id: 220,
        name: "email_server_view",
      },
      {
        id: 221,
        name: "email_server_create",
      },
      {
        id: 222,
        name: "email_server_edit",
      },
      {
        id: 223,
        name: "email_server_delete",
      },
      {
        id: 224,
        name: "email_template_view",
      },
      {
        id: 225,
        name: "email_template_create",
      },
      {
        id: 226,
        name: "email_template_edit",
      },
      {
        id: 227,
        name: "email_template_delete",
      },
      {
        id: 228,
        name: "notification_view",
      },
      {
        id: 229,
        name: "notification_create",
      },
      {
        id: 230,
        name: "notification_edit",
      },
      {
        id: 231,
        name: "notification_delete",
      },
      {
        id: 232,
        name: "reference_view",
      },
      {
        id: 233,
        name: "reference_create",
      },
      {
        id: 234,
        name: "reference_edit",
      },
      {
        id: 235,
        name: "reference_delete",
      },
      {
        id: 236,
        name: "userroles_settings_view",
      },
      {
        id: 237,
        name: "userroles_settings_create",
      },
      {
        id: 238,
        name: "userroles_settings_edit",
      },
      {
        id: 239,
        name: "userroles_settings_delete",
      },
      {
        id: 240,
        name: "user_settings_view",
      },
      {
        id: 241,
        name: "user_settings_edit",
      },
      {
        id: 242,
        name: "project_settings_view",
      },
      {
        id: 243,
        name: "project_settings_create",
      },
      {
        id: 244,
        name: "project_settings_delete",
      },
      {
        id: 245,
        name: "activity_task_settings_view",
      },
      {
        id: 246,
        name: "activity_task_settings_create",
      },
      {
        id: 247,
        name: "activity_task_settings_delete",
      },
      {
        id: 248,
        name: "mydiary_settings_view",
      },
      {
        id: 249,
        name: "mydiary_settings_create",
      },
      {
        id: 250,
        name: "mydiary_settings_delete",
      },
      {
        id: 251,
        name: "man_power_role_settings_view",
      },
      {
        id: 252,
        name: "man_power_role_settings_create",
      },
      {
        id: 253,
        name: "man_power_role_settings_edit",
      },
      {
        id: 254,
        name: "man_power_role_settings_delete",
      },
      {
        id: 255,
        name: "job_role_settings_view",
      },
      {
        id: 256,
        name: "job_role_settings_create",
      },
      {
        id: 257,
        name: "job_role_settings_delete",
      },
      {
        id: 258,
        name: "notification_settings_view",
      },
      {
        id: 259,
        name: "notification_settings_edit",
      },
      {
        id: 260,
        name: "unit_settings_view",
      },
      {
        id: 261,
        name: "unit_settings_create",
      },
      {
        id: 262,
        name: "unit_settings_delete",
      },
      {
        id: 263,
        name: "finance_settings_view",
      },
      {
        id: 264,
        name: "finance_settings_create",
      },
      {
        id: 265,
        name: "finance_settings_delete",
      },
      {
        id: 266,
        name: "category_settings_view",
      },
      {
        id: 267,
        name: "category_settings_create",
      },
      {
        id: 268,
        name: "category_settings_delete",
      },
      {
        id: 269,
        name: "division_settings_view",
      },
      {
        id: 270,
        name: "division_settings_create",
      },
      {
        id: 271,
        name: "division_settings_delete",
      },
      {
        id: 272,
        name: "bidding_status_settings_view",
      },
      {
        id: 273,
        name: "bidding_status_settings_create",
      },
      {
        id: 274,
        name: "bidding_status_settings_delete",
      }
    ]
  }
];